// removed by extract-text-webpack-plugin
module.exports = {"numericTextBox":"AuditItemsPopover__numericTextBox__2T7jA","numericTextBoxLabel":"AuditItemsPopover__numericTextBoxLabel__1g9u2"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/AuditTemplateDetailView/AuditItems/AuditItemsPopover/AuditItemsPopover.scss
// module id = 1742
// module chunks = 0